<template>
    <div class="content">
        <div style="height: 100%;width: 100%;overflow-y: scroll">
            <div style="width: 82%;text-align: left;font-size: 18px;color: black;font-weight: 700;margin: 40px auto 0 auto;">卫星溯源用户服务协议与隐私政策</div>
            <div class="paragraph2" style="margin-top: 20px">
                发布日期：2026年5月18日
            </div>
            <div class="paragraph2">
                生效日期：2026年5月18日
            </div>
            <div style="clear: both"></div>
            <div class="paragraph" style="margin-top: 30px">
                本<strong>《卫星溯源用户服务协议与隐私政策》（简称“本服务协议”）</strong>是您使用卫星溯源小程序（以下简称“平台”）期间各种服务等相关事宜所订立的协议。<strong>为使用卫星溯源的服务，您应当仔细阅读并遵守本服务协议下的全部内容，特别是涉及免除或者责任限制的条款，该类条款已以加粗的形式提示您重点注意。</strong>除非您已阅读并接受本服务协议所有条款，否则您将不能使用卫星溯源核验反馈功能，进行提交反馈、上传材料、填写联系方式等行为。如您对本服务协议的内容（特别是涉及免除或者责任限制的条款）有任何疑义，可随时按照本服务协议中列明的联系方式与我们联系，我们将根据您的要求为您进一步解释和说明相关内容。<strong>如您勾选“我同意《卫星溯源用户服务协议与隐私政策》”，即视为您已阅读并同意本服务协议，自愿接受本服务协议的所有内容约束。请您在使用卫星溯源核验反馈功能前再次确认您已知悉并完全理解本服务协议的所有内容。</strong>
            </div>
            <div class="paragraph" style="margin-top: 20px">
              <strong>如果您未满18周岁，请务必在家长和其他法定监护人的陪同下阅读本服务协议，并在使用卫星溯源核验反馈功能进行提交反馈、上传材料、填写联系方式等任何行为前，应事先征得您的家长和其他法定监护人的同意。未满14周岁未成年人禁止主动提交手机号、图片等个人敏感信息；14-18周岁未成年人需监护人明示同意后方可使用反馈功能。我们仅收集完成反馈所必需的最少信息，严格保护您的隐私与个人信息安全。</strong>
            </div>

            <div class="subTitle">一、用户服务协议</div>

            <div class="subTitle2">第一条 协议主体与服务内容</div>
            <div class="paragraph">
                1.1 本协议由您与<strong>长光卫星技术股份有限公司（以下简称“我们”）</strong>签订，适用于卫星溯源小程序全部核验、反馈、查询服务功能。
            </div>
            <div class="paragraph">
                1.2 为您提供<strong>农产品产地真实性、地块信息异常</strong>反馈通道，您可提交问题描述、上传佐证材料。
            </div>
            <div class="paragraph">
                1.3 我们将结合卫星影像数据、地块权属信息、溯源平台数据对反馈内容进行核验、处理与公示。
            </div>
            <div class="paragraph">
                1.4 我们可根据业务需要优化服务流程、页面与审核规则，微小优化无需单独通知，重大规则变更将在平台首页公示。
            </div>

            <div class="subTitle2">第二条 用户权利与义务</div>
            <div class="paragraph">
                2.1 您有权自愿、真实、客观地提交反馈，查询处理进度。
            </div>
            <div class="paragraph">
                2.2 您承诺提交的文字、图片等<strong>内容真实、合法、无伪造、不诽谤、不恶意举报。</strong>
            </div>
            <div class="paragraph">
                2.3 您保证不侵犯第三方隐私、肖像、名誉、著作权、商业秘密等合法权益。
            </div>
            <div class="paragraph">
                2.4 您不得利用本功能进行敲诈勒索、造谣、刷单、不正当竞争等违法违规行为。
            </div>
            <div class="paragraph">
                2.5 您自愿填写的手机号码<strong>仅用于核实反馈、电话及短信回复处理结果，</strong>绝不用于商业营销、短信骚扰。
            </div>

            <div class="subTitle2">第三条 平台权责与服务限制</div>
            <div class="paragraph">
                3.1 平台将按照用户提交的反馈信息，协助对接相关责任方处理问题，但不对问题的处理结果、处理时效作出承诺，仅提供信息传递与协调服务。
            </div>
            <div class="paragraph">
                3.2 平台有权对用户提交的内容进行审核，对违反法律法规、本协议或平台规则的内容，有权不予通过、删除或屏蔽，并视情节采取限制使用、封禁账号等措施。
            </div>
            <div class="paragraph">
                3.3 平台将尽合理努力保障服务的正常运行，但因不可抗力、网络故障、第三方服务中断等非平台可控因素导致的服务中断或数据丢失，平台不承担责任。
            </div>

            <div class="subTitle2">第四条 知识产权与内容归属</div>
            <div class="paragraph">
                4.1 平台内卫星影像、地图、地块数据、页面设计、认证标识等知识产权归我们所有。
            </div>
            <div class="paragraph">
                4.2 您上传的原创内容，授权我们<strong>全球、免费、非独家</strong>使用，仅限用于反馈核验、处理、公示及合规举证。
            </div>
            <div class="paragraph">
                4.3 因您上传内容侵权导致纠纷、索赔的，由您承担全部责任；给我们造成损失的，我们有权追偿。
            </div>

            <div class="subTitle2">第五条 免责条款</div>
            <div class="paragraph">
                5.1 我们仅提供反馈渠道与核验处理服务，<strong>不对用户上传内容的真实性、合法性承担担保责任。</strong>
            </div>
            <div class="paragraph">
                5.2 因网络故障、系统维护、第三方行为、不可抗力等导致服务中断或延迟的，我们不承担赔偿责任。
            </div>
            <div class="paragraph">
                5.3 因您提交虚假、侵权、恶意内容产生的一切法律责任与损失，由您自行承担。
            </div>

            <div class="subTitle2">第六条 协议修改与终止</div>
            <div class="paragraph">
                6.1 我们可适时修订本协议，修订后在小程序内公示，<strong>继续使用即视为接受修订内容。</strong>
            </div>
            <div class="paragraph">
                6.2 您停止使用本功能，本协议即对您终止；终止前的行为仍受本协议约束。
            </div>

            <div class="subTitle">二、隐私政策</div>

            <div class="subTitle2">第一条 政策目的与适用范围</div>
            <div class="paragraph">
                1.1 本政策旨在说明平台如何收集、使用、存储、保护用户在使用卫星溯源核验反馈服务过程中提供的个人信息，保障用户的信息安全与合法权益。
            </div>
            <div class="paragraph">
                1.2 本政策适用于用户使用本服务的全过程，您使用本服务即表示您同意平台按照本政策收集、使用和保护您的信息。
            </div>

            <div class="subTitle2">第二条 信息收集范围与目的</div>
            <div class="paragraph">
                平台仅收集实现服务功能所必需的信息，具体如下：
            </div>
            <div class="paragraph">
                2.1 您主动填写的反馈信息：问题类型、地块编号、问题描述；
            </div>
            <div class="paragraph">
                2.2 您主动上传的佐证材料：图片资料，仅用于问题核验、案情举证；
            </div>
            <div class="paragraph">
                2.3 您自愿填写的联系方式：手机号码（仅用于回复结果）；
            </div>
            <div class="paragraph">
                2.4 自动静默收集信息：为保障小程序安全运行，我们将自动获取设备型号、网络类型、小程序访问日志、操作记录，该类信息无法手动关闭，仅用于风控防刷、系统运维，不对外泄露。
            </div>
            <div class="paragraph">
                平台不会收集与本服务无关的个人信息，也不会在未获得用户明示同意的情况下，向第三方收集、购买用户个人信息。
            </div>

            <div class="subTitle2">第三条 信息使用规则</div>
            <div class="paragraph">
                3.1 平台仅将收集的用户信息用于以下目的：
            </div>
            <div class="paragraph">
                （1）处理用户提交的地块问题反馈，对接相关责任方进行核实与处置；
            </div>
            <div class="paragraph">
                （2）通过用户提供的联系方式，与用户沟通问题处理相关事宜；
            </div>
            <div class="paragraph">
                （3）优化本服务的功能与体验，提升反馈处理效率；
            </div>
            <div class="paragraph">
                （4）遵守法律法规、监管要求或司法机关的指令。
            </div>
            <div class="paragraph">
                3.2 平台<strong>不会向任何第三方出售、转让或公开用户的个人信息；</strong>因服务需要，向技术运维、政务对接等第三方合规共享用户信息的，将严格要求第三方履行保密义务，且仅共享实现服务必需的最小范围信息，未经用户明示同意，不会向无关第三方共享。
            </div>

            <div class="subTitle2">第四条 信息存储与保护</div>
            <div class="paragraph">
                4.1 信息存储期限：用户提交的反馈信息及相关材料，自问题处理完毕之日起保存不超过3年，法律法规另有规定的从其规定；用户的联系方式信息仅在问题处理周期内使用，处理完毕后将进行脱敏处理或删除；日志类、设备类信息留存期限不超过90天，符合网信办相关要求。
            </div>
            <div class="paragraph">
                4.2 信息保护措施：平台采用符合行业标准的加密技术、访问控制机制保护用户信息，限制仅授权工作人员可访问联系方式等敏感信息，并定期开展安全检查，防止信息泄露、篡改或丢失。
            </div>
            <div class="paragraph">
                4.3 敏感信息处理：涉及身份证号、手机号、金额、签名等内容，<strong>一律脱敏、打码、不对外公开。</strong>
            </div>

            <div class="subTitle2">第五条 用户的信息权利</div>
            <div class="paragraph">
                您可通过客服电话依法行使以下权利，我们将在15个工作日内响应：
            </div>
            <div class="paragraph">
                5.1 查询、更正您提交的反馈内容；
            </div>
            <div class="paragraph">
                5.2 删除您的联系方式及反馈信息（无合规留存要求时）；
            </div>
            <div class="paragraph">
                5.3 撤回对联系方式使用的同意（撤回后可能无法电话回复结果）；
            </div>
            <div class="paragraph">
                5.4 您有权申请账号注销，我方在核验身份后15个工作日内完成注销，并清除非法定留存数据；
            </div>
            <div class="paragraph">
                5.5 您有权申请导出本人提交的个人信息，有权拒绝平台收集非必要个人信息。
            </div>

            <div class="subTitle2">第六条 未成年人信息保护</div>
            <div class="paragraph">
                平台不主动收集未成年人的个人信息。未满14周岁未成年人禁止主动提交手机号、图片等个人敏感信息；14-18周岁未成年人需监护人明示同意后方可使用反馈功能。若您是未成年人，请在监护人的陪同下阅读本政策，并在监护人同意后使用本服务。如发现平台收集了未成年人的个人信息，监护人可联系平台要求删除相关信息。
            </div>

            <div class="subTitle2">第七条 政策更新与联系方式</div>
            <div class="paragraph">
                7.1 平台有权根据业务调整或法律法规更新本政策，更新后的政策将在小程序内公示，用户继续使用本服务即视为同意更新后的政策。
            </div>
            <div class="paragraph">
                7.2 如您对本政策有任何疑问、意见或建议，可通过以下方式联系平台：
            </div>
            <div class="paragraph">
                运营主体：长光卫星技术股份有限公司
            </div>
            <div class="paragraph">
                注册地址：吉林省长春市宽城区明溪路1299号
            </div>
            <div class="paragraph">
                联系电话：0431-86008580
            </div>

            <div style="width: 100%;height: 80px;"></div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
    }
</script>

<style>
    .content {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: white;
        z-index: -1;
    }

    .subTitle {
        width: 82%;
        margin: 0 auto;
        font-size: 16px;
        color: black;
        text-align: left;
        line-height: 22px;
        margin-top: 25px;
        font-weight: 700;
    }

    .subTitle2 {
        width: 82%;
        margin: 0 auto;
        font-size: 12px;
        color: black;
        text-align: left;
        line-height: 20px;
        margin-top: 18px;
        font-weight: 600;
    }

    .paragraph {
        width: 82%;
        margin: 0 auto;
        font-size: 12px;
        color: #7C7B7B;
        text-align: left;
        line-height: 22px;
        text-indent: 0px;
    }

    .paragraph2 {
        width: 82%;
        font-size: 12px;
        color: #7C7B7B;
        text-align: left;
        line-height: 18px;
        margin-top: 5px;
        text-indent: 0;
    }

    strong {
        font-weight: 500;
        color: black;
    }
</style>